import React from 'react';

import { makeStyles } from '@material-ui/core/styles';
import MuiTooltip from '@material-ui/core/Tooltip';

import InfoOutlinedIcon from '@material-ui/icons/InfoOutlined';
import clsx from 'clsx';
import PropTypes from 'prop-types';

import styles from './styles';

export const useStyles = makeStyles(styles);
export function Tooltip(props) {
  const { children, className, hasInfoIcon = true, TitleContent, iconProps, classes: classesProp, ...other } = props;
  const classes = useStyles({ classes: classesProp });

  const { tooltipContent: tooltipContentStyle, infoIcon: infoIconStyle, ...muiTooltipClasses } = classes;

  return (
    <MuiTooltip
      data-testid='tooltip'
      title={TitleContent}
      className={className}
      classes={muiTooltipClasses}
      arrow
      {...other}
    >
      <span className={clsx(tooltipContentStyle, 'Tooltip-Children')}>
        {children}
        {hasInfoIcon && <InfoOutlinedIcon className={clsx(infoIconStyle, 'InfoIcon')} {...iconProps} />}
      </span>
    </MuiTooltip>
  );
}

Tooltip.defaultProps = {
  hasInfoIcon: true,
};

Tooltip.propTypes = {
  className: PropTypes.string,
  /** Content of the items to be hovered over */
  children: PropTypes.node,
  /** Overwrites classes */
  classes: PropTypes.object,
  /** Indicates whether info icon is present. Default to true */
  hasInfoIcon: PropTypes.bool,
  /** Contents to be showed in the tooltip */
  TitleContent: PropTypes.node,
  /** Props passed into Icon component */
  iconProps: PropTypes.object,
};

export default Tooltip;
